import { Form } from "antd";
import { useParams } from "react-router";

import { AidPreferencesClessTable } from "src/app/features/EmvKernelProfile/subFeatures/AidPreferenceCless/components/tables/AidPreferencesClessTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const EmvKernelProfilesAidPreferencesClessTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <AidPreferencesClessTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
